// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__8o4w0","blink":"LoadingDots_blink__iunUN"};